// ================
// Faq
// ================

var faqItem = $(".faq__item");
$(".faq__item.is-active .faq__answer").css('display', 'block');

faqItem.each(function (i, item) {
    item.onclick = function (e) {
        if ($(".faq__item.is-active").length == 1) {
            $(".faq__item").not(this).find('.faq__answer').slideUp()
            $(".faq__item").not(this).removeClass('is-active');
        }
        $(this).toggleClass('is-active');
        $(this).find('.faq__answer').slideToggle();
    };
});